import React, { useEffect, useState } from "react";

import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Autocomplete, FormControl, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { newHost } from "../Categories/CategoryProfile";
import defaultImage from "../../assets/svg/defultImage.svg";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";



const BranchContacts = ({ nestIndex, control, register, contactTypes }) => {
  const {
    fields: contactFields,
    append: appendContact,
    remove: removeContact,
  } = useFieldArray({
    control,
    name: `branches.${nestIndex}.contacts`,
  });

  return (
    <>
      {contactFields.map((contact, index) => (
        <div className="row" key={contact.id}>
          <div className="col-md-6">
            <Controller
              name={`branches.${nestIndex}.contacts.${index}.contact_type_id`}
              control={control}
              render={({ field }) => (
                <FormControl className="w-100">
                  <label htmlFor="">Contact Type</label>

                  <Select  {...register(`branches.${nestIndex}.contacts.${index}.contact_type_id`)}
                    size="small"
                    labelId="contact-type-label"
                    label=""
                    value={field.value || []}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    {contactTypes.map((type) => (
                      <MenuItem
                        key={type.id}
                        value={type.id}
                        className="custom-menu-item "

                      >
                        <div className='label-size m-0'>                            {type.name}
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="">Contact Info</label>

            <div className="w-100 d-flex align-items-center gap-1 input-group-responsive">
              <TextField
                size="small"
                {...register(`branches.${nestIndex}.contacts.${index}.info`)}

                placeholder="Contact Info"
                className="w-100"
              />
              <div className="d-flex mb-3 gap-2">
                <button
                  type="button"
                  onClick={() => appendContact({ contact_type_id: "", info: "" })}
                  className="btn btn-light"
                >
                  +
                </button>
                <button
                  type="button"
                  onClick={() => removeContact(index)}
                  className="btn btn-light"
                >
                  -
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

function Supplier() {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const [providerServices, SetProviderServices] = useState([])
  const [imagePreview, setImagePreview] = useState(null)
  const [provider, setProvider] = useState({});

  const [providerId, setProviderId] = useState(null)
  const [branchTypes, setBranchTypes] = useState([])
  const [contactTypes, setContactTypes] = useState([])
  const { id } = useParams()
  const [isEdit, setIsEdit] = useState(false)

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    control,
  } = useForm({
    defaultValues: {
      name: '',
      website: '',
      username: '',
      type: '',
      logo_url: "",
      password: '',
      password_confirmation: '',
      services: [],
      branches: [{
        name: '',
        type_id: '',
        address: {
          address: ''
        },
        contacts: [{ contact_type_id: '', info: '' }]
      }]
    }
  })
  const {
    fields: contactFields,
    append: appendContact,
    remove: removeContact,
  } = useFieldArray({
    control,
    name: "contacts",
  });



  const { fields: branchFields, } = useFieldArray({
    control,
    name: "branches",
  });




  const submitProvider = async (data) => {
    const formData = new FormData();
    formData.append("logo", data.logo_url);

    formData.append("name", data.name);
    formData.append("username", data.username);

    if (!isEdit) {
      formData.append("password", data.password);
      formData.append("password_confirmation", data.password_confirmation);
    }
    formData.append("type", data.type);
    formData.append("website", data.website);

    formData.append("branch[name]", data.branch.name);
    formData.append("branch[type_id]", data.branch.type_id);

    formData.append("branch[address][address]", data.branch.address.address || "");

    data.branches.map((branch) =>
      branch.contacts.forEach((contact, idx) => {
        formData.append(`branch[contacts][${idx}][contact_type_id]`, contact.contact_type_id || "");
        formData.append(`branch[contacts][${idx}][info]`, contact.info || "");
      })
    )

    data.services.forEach((service, idx) => {
      formData.append(`services[${idx}]`, service || "");
    });


    console.log(data);

    if (isEdit) formData.append("_method", "PUT");

    try {
      const url = isEdit
        ? `${newHost}portal/providers-with-branches/${providerId}/full`
        : `${newHost}portal/providers-with-branches`;

      const response = await axios.post(url, formData, {
        headers: newHeaders,
      });

      toast.success(response.data.data.message);
      navigate("/stock/vendors");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message);
    }
  };


  const FileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {

        setImagePreview(reader.result);
        setValue("logo_url", file);

      };

      reader.readAsDataURL(file);
    }
  };


  const getProviderSupportedServices = async () => {
    try {
      const response = await axios.get(`${newHost}portal/provider_supported_services`,
        {
          headers: newHeaders
        }
      );
      console.log(response);

      SetProviderServices(response.data.data.services);
    } catch (error) {
      console.log(error);
    }
  };

  const getProviderBranchTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/branch_types`,
        {
          headers: newHeaders
        }
      );
      console.log(response);

      setBranchTypes(response.data.data.branchTypes);
    } catch (error) {
      console.log(error);
    }
  };

  const getProviderContactTypes = async () => {
    try {
      const response = await axios.get(`${newHost}contact_types`,
        {
          headers: newHeaders
        }
      );
      console.log(response);

      setContactTypes(response.data.data?.contactTypes);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProvider = async () => {

    setProviderId(id)
    try {
      const res = await axios.get(`${newHost}portal/providers-with-branches/${id}`, {
        headers: newHeaders,
      });

      const providerData = res.data.data.provider;

      setProvider(providerData);

      setValue("name", providerData.name);
      setValue("username", providerData.username);
      setValue("website", providerData.website);
      setValue("type", providerData.type);
      setValue("services", providerData.services?.map(s => s.id) || []);

      if (providerData.logo_url) {
        setImagePreview(newImageUrl + providerData.logo_url);
      }


      providerData.branches?.forEach((branch, index) => {
        setValue(`branch.name`, branch.name || "");
        setValue(`branch.type_id`, branch.type_id || "");
        setValue(`branch.address.address`, branch.address?.address || "");

        branch.contacts?.forEach((contact, cidx) => {
          setValue(`branches.${index}.contacts.${cidx}.contact_type_id`, contact.contact_type_id);
          setValue(`branches.${index}.contacts.${cidx}.info`, contact.info);
        });
      });


    } catch (error) {
      console.log(error);
    }


  };

  useEffect(() => {
    getProviderSupportedServices();
    getProviderBranchTypes();
    getProviderContactTypes();

    if (id) {
      setIsEdit(true);
      fetchProvider();
    } else {
      setIsEdit(false);
    }
  }, []);










  return (
    <>


      <div className="min-vh-100 ">
        <div className="m-4 p-3">
          <div className="supplier_title">{isEdit ? "Update Vendor" : "Add New Vendor"}</div>
          <form onSubmit={handleSubmit(submitProvider)} className="supplier_data p-4 rounded-4 ">
            <div className="supplier_companyInfo ">
              <h5 className="fw-bold  border-bottom py-3">1. Company Info</h5>
              <p className='spplier-profile-label-color  fw-medium supplier-label-size'>Company Logo</p>

              <div className=" d-flex justify-content-between align-items-center p-5 company-logo-upload input-group-responsive">
                <div style={{ width: "300px", height: "80px" }} className="d-flex align-items-center input-group-responsive">
                  <img
                    className="w-25 h-100"
                    src={
                      imagePreview
                        ? imagePreview
                        : provider?.logo_url
                          ? newImageUrl + provider.logo_url
                          : defaultImage
                    }
                    alt="Logo Preview"
                  />

                  {isEdit && provider.logo_url || imagePreview ? null : <p className="fw-bold my-0 mx-2 supplier-label-size">Upload an image. Max size 2MB</p>
                  }

                </div>
                <label htmlFor="company-logo" className="btn btn-light">

                  Browser
                  <input onChange={FileChange} type="file" id="company-logo" className="d-none " />


                </label>

              </div>
              <div className="row my-2">
                <div className="col-md-6">
                  <label htmlFor="">Company Name</label>
                  <TextField
                    size="small"
                    className='w-100 ' type='text' placeholder='EX: Arab Company' label=""
                    {...register("name")}
                  />
                </div>
                <div className="col-md-6">
                  <label className="" htmlFor="">Website Link</label>

                  <div className="position-relative d-flex justify-content-start align-items-center w-100">
                    <TextField
                      size="small"
                      className='w-100' type='text' placeholder='Enter Website Link' label=""
                      {...register("website")}
                    />
                  </div>
                </div>
              </div>
              <div className="row my-2">
                <div className="col-md-6">
                  <label htmlFor="">Type</label>
                  <Controller
                    name={`type`}
                    control={control}
                    render={({ field }) => {
                      const options = ["provider", "supplier"].map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <>
                          <Autocomplete

                            size="small"
                            options={options}


                            onChange={(e, item) => {
                              field.onChange(item ? item.id : null);
                            }}
                            value={options.find(opt => opt.id == field.value) || null}


                            renderOption={(props, option) => (
                              <li
                                {...props}
                                className="p-2"
                              >
                                {option.label}
                              </li>
                            )}
                            renderInput={(params) => <TextField {...params} placeholder="Select Vendor Type" />}
                          />

                        </>
                      );
                    }}
                  />

                </div>
                <div className="col-md-6">
                  <label htmlFor="">User Name</label>

                  <TextField
                    size="small"
                    className='w-100 ' type='text' placeholder='Enter User Name' label=""
                    {...register("username")}
                  />
                </div>
              </div>
              {isEdit ? null : <div className="row my-2">
                <div className="col-md-6">
                  <label htmlFor="">Password</label>
                  <TextField
                    size="small"
                    className='w-100' type='text' placeholder='Enter Password' label=""
                    {...register("password")}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="">confirmation Password</label>
                  <TextField
                    size="small"
                    className='w-100 ' type='text' placeholder='Enter confirmation password' label=""
                    {...register("password_confirmation")}
                  />
                </div>

              </div>}


              <h5 className="fw-bold  border-bottom my-2 py-3">2. Services</h5>

              <div className="">
                <label htmlFor="">Services</label>
                <Controller
                  name="services"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      multiple
                      size="small"
                      className="w-100"
                      disableCloseOnSelect
                      value={providerServices.filter((s) =>
                        (field.value || []).includes(s.id)
                      )}

                      onChange={(e, newValue) => {
                        field.onChange(newValue.map((v) => v.id));
                      }}

                      options={providerServices}
                      getOptionLabel={(option) => option.name}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                          const tagProps = getTagProps({ index });

                          return (
                            <span
                              {...tagProps}
                              key={option.id}
                              className="d-flex align-items-center mx-1"
                              style={{
                                padding: "2px 6px",
                                borderRadius: "12px",
                                backgroundColor: "#e0e0e0",
                                fontSize: "0.8rem",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <img
                                src={
                                  option.image
                                    ? newImageUrl + option.image.image_url
                                    : defaultImage
                                }
                                alt=""
                                style={{
                                  width: 18,
                                  height: 18,
                                  borderRadius: "50%",
                                }}
                              />

                              <span>{option.name}</span>

                              <span
                                onClick={tagProps.onDelete}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  lineHeight: 1,

                                  color: "#555",
                                }}
                              >
                                <Close  sx={{ color: "red",fontSize:"16px" }} />
                              </span>
                            </span>
                          );
                        })
                      }

                      renderOption={(props, option, state) => (
                        <li
                          {...props}
                          className="custom-menu-item"
                          style={{
                            padding: "10px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            direction: "rtl",
                            margin: "5px",


                            backgroundColor: state.selected
                              ? "rgba(193, 203, 213, 0.15)"
                              : state.hovered
                                ? "rgba(175, 175, 175, 0.06)"
                                : "transparent",

                            borderRadius: "6px",
                          }}
                        >
                          <img
                            src={
                              option.image
                                ? newImageUrl + option.image.image_url
                                : defaultImage
                            }
                            alt=""
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: "50%",
                            }}
                          />

                          <div className="label-size m-0">{option.name}</div>
                        </li>
                      )}

                      ListboxProps={{
                        style: {
                          maxHeight: 220,
                          overflowY: "auto",
                          direction: "rtl",
                          padding: "6px",
                        },
                      }}

                      renderInput={(params) => (
                        <TextField

                          {...params}
                        />
                      )}
                    />
                  )}

                />
              </div>
              <div className="d-flex justify-content-between align-align-items-center border-bottom my-2 py-3">
                <h5 className="fw-bold m-0">3. Branches</h5>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="">Main Branch</label>
                  <TextField
                    size="small"
                    className='w-100 ' type='text' placeholder='Enter Name' label=""
                    {...register("branch[name]")}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="">Address</label>
                  <TextField
                    size="small"
                    className='w-100 ' type='text' placeholder='Enter Address' label=""
                    {...register("branch[address][address]")}
                  />
                </div>
              </div>


              {/* Add Contact Fields */}
              <div className="row ">
                {branchFields.map((branch, idx) => (
                  <div key={branch.id} className=" p-3">
                    <BranchContacts
                      nestIndex={idx}
                      control={control}
                      register={register}
                      contactTypes={contactTypes}
                    />
                  </div>
                ))}


              </div>
              <div className="row">

                <div className="col-md-6">

                  <Controller
                    name="branch.type_id"
                    control={control}
                    render={({ field }) => (
                      <FormControl className="w-100" variant="outlined">
                        <label htmlFor="">Branch Type</label>

                        <Select
                          size="small"

                          labelId=""
                          label=""
                          value={field.value || []}
                          onChange={(e) => field.onChange(e.target.value)
                          }
                        >
                          {branchTypes.map((type) => (
                            <MenuItem
                              key={type.id}
                              value={type.id}
                              className="custom-menu-item "

                            >
                              <div className='label-size m-0'>                            {type.name}
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

              </div>

            </div>
            <div className="d-flex justify-content-center p-4 ">
              <button className="btn btn-dark px-5">Save</button>
            </div>
          </form>

        </div>

      </div>

    </>
  );
}

export default Supplier;
